import { msalInstance } from 'journeys/common/header/subSections/UserDropdown/UserDropdown';
import { entries } from 'idb-keyval';
import offlineStore from 'utils/OfflineDB';
import { syncMRATData } from 'components/MRATSync/MRATSync';

export const handleLogOutFunction = async ({
    updateInvalidationStatus,
    checkOfflineFormDataPresent,
    setCurrentAppView,
    disableSyncButton,
    setLogOutAlert,
}) => {
    if (setLogOutAlert) setLogOutAlert(false);
    const accounts = msalInstance.getAllAccounts();
    const storesOfflineValues = await entries(offlineStore);
    if (storesOfflineValues.length !== 0) {
        await syncMRATData({
            storesOfflineValues,
            updateInvalidationStatus,
            checkOfflineFormDataPresent,
            setCurrentAppView,
            disableSyncButton,
        });
    }
    const logoutRequest = { account: accounts[0] };
    if (logoutRequest?.account?.username?.toLowerCase().includes('bp')) {
        msalInstance.logoutRedirect();
    } else {
        msalInstance.logoutRedirect(logoutRequest);
    }
};
